/**
 * Returns whether the browser can create a WebGL context (1.x or 2).
 * Used before mounting Babylon.js to avoid a blank canvas / uncaught engine errors.
 */
export function isWebGLSupported(): boolean {
  try {
    const canvas = document.createElement("canvas");
    const gl =
      canvas.getContext("webgl") ||
      canvas.getContext("experimental-webgl") ||
      canvas.getContext("webgl2");
    return !!(window.WebGLRenderingContext && gl);
  } catch {
    return false;
  }
}